
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { PaginatableList } from "apiTypes";
import { CheckoutSteps, resetCheckoutStore, useCheckoutStore, } from "components/ReuseableCompos/SharedDonatePages/DonateModal/CheckoutState";
import SponsorCard from "components/ReuseableCompos/SharedDonatePages/SponsorCard";
import InfinteDataSoruceHandler from "components/SharedLayoutComponents/InfinteDataSoruceHandler";
import { NEXT_URL_PROXY } from "config";
import { useAuthContext } from "context/AuthContext";
import { AuthModalContext } from "context/AuthModalContext";
import SponsorMeLayout from "layout/SponsorMeLayout";
import { useContext } from "react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { SWRInfiniteConfiguration } from "swr/infinite";
import { getData } from "utils/getData";
const SponsorMe = () => {
    const swrOptions: SWRInfiniteConfiguration<PaginatableList<any>> = {
        revalidateOnFocus: false,
        revalidateOnMount: true,
        revalidateIfStale: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false,
        refreshWhenHidden: false
    };
    const { donor } = useAuthContext();
    const { handleShowAuthModal, onTabClick } = useContext(AuthModalContext);
    const setModalVisible = useCheckoutStore((state) => state.setModalVisible);
    const setPaymentOptionData = useCheckoutStore((state) => state.setPaymentOptionData);
    const setPaymentOptions = useCheckoutStore((state) => state.setPaymentOptions);
    const addStepToHistory = useCheckoutStore((state) => state.addStepToHistory);
    const onDonateClick = async (id: number) => {
        if (!donor) {
            handleShowAuthModal();
            onTabClick("with_social");
            return;
        }
        resetCheckoutStore();
        const formattedData = await getData(`${NEXT_URL_PROXY}/targetables/sponsorships/${id}/payment-options`);
        setPaymentOptions(formattedData.data.data);
        setPaymentOptionData({
            targetableId: id.toString(),
            targetableType: "sponsorship",
            payment_options_label: formattedData?.data?.payment_options_label
        });
        addStepToHistory(CheckoutSteps.PaymentOptionStep.name);
        setModalVisible(true);
    };
    return (<div className="mb-5">
      <InfinteDataSoruceHandler skeleton={SponsorCard} skeletonProps={{ skeleton: true }} endPoint={"targetables/sponsorships"} resourceName="data" skeletonAmount={15} getMoreSkeletonAmount={15} skeletonContainerClassName="sponsor-me-container" inifiteScrollClassName="sponsor-me-container" inifiteScrollProps={{
            no100vh: true
        }} proxy={false} swrOptions={swrOptions}>
        <SponsorCard onDonateClick={onDonateClick}/>
      </InfinteDataSoruceHandler>
    </div>);
};
SponsorMe.Layout = SponsorMeLayout;
export default SponsorMe;

    async function __Next_Translate__getStaticProps__1a13f66bde8__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sponsor-me',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bde8__ as getStaticProps }
  